import * as DeviceApiUtil from "../../util/device_util";

export const RECEIVE_ALL_DEVICES = "RECEIVE_ALL_DEVICES"

const receiveAllDevices = (devices) => {
    return {
        type: RECEIVE_ALL_DEVICES,
        devices
    }
}

export const fetchAllDevices = (cancelToken) => dispatch => {
    return DeviceApiUtil.fetchAllDevices(cancelToken)
        .then(devices => { dispatch(receiveAllDevices(devices)) })
};